import { ReactElement, useContext } from "react";
import styles from "./PayNavigation.module.css";
import { SystemIcon } from "@justworkshr/milo-icons";
import { buildASOPath } from "lib/resource-finder";
import { ADDITIONAL_PAY_FORM_ROUTES } from "../../constants";
import { useParams } from "react-router";
import { AdditionalPayContext } from "../../contexts/additionalPayContext";
import { useGetMemberPermissionsQuery } from "types/generated/operations";

const getFormTitle = (formType: string) => {
  switch (formType) {
    case ADDITIONAL_PAY_FORM_ROUTES.REIMBURSEMENT:
      return "Expense Reimbursement";
    case ADDITIONAL_PAY_FORM_ROUTES.TAXABLEBENEFITSANDALLOWANCES:
      return "Benefits & allowances";
    case ADDITIONAL_PAY_FORM_ROUTES.EMPLOYEE_PAY:
      return "Employee Pay";
    default:
      return "Edit payment details";
  }
};

export const PayNavigation = (): ReactElement => {
  const { formType } = useParams();
  const additionalPayContext = useContext(AdditionalPayContext);
  const isEdit = additionalPayContext?.isEdit;
  const { data } = useGetMemberPermissionsQuery();
  const cdmsId =
    data?.authenticatedMember?.company?.cdmsCanonicalCompanyId ?? "";

  return (
    <>
      <div className={styles.nav}>
        <SystemIcon iconName="arrow-left" size="small" color="brand" />
        <a
          href={buildASOPath(
            cdmsId
              ? `/${cdmsId}/pay/payments-center/international`
              : `/pay/payments-center/international`
          )}
        >
          Back to Payment center
        </a>
      </div>

      <h1>
        {!isEdit && getFormTitle(formType || "")}{" "}
        {isEdit && "Edit payment details"}
      </h1>
    </>
  );
};
